export default __webpack_public_path__ + "static/media/vodafonecash.679cdc39.png";